var $718705a15b8a633a$exports = {};
$718705a15b8a633a$exports = {
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Valige \xfcksus`,
    "tableResizer": `Suuruse muutja`
};


export {$718705a15b8a633a$exports as default};
//# sourceMappingURL=et-EE.module.js.map
